import { FormatNumberWithCommas } from "../../../../../../shared/scripts/number-functions";
import { TableColumnGroup, TableColumnVisibilityController } from "../../../../../../shared/scripts/table-column-visibility";
import { RenderDateMDY, RenderDateYMD, RenderNullableNumberWithSeparators, RenderNullableString } from "../../../../../../shared/scripts/table-functions";
import { MilestonesBySite } from "../../scripts/site-activation.entities";
import { SiteActivationLookup } from "../../scripts/site-activation.lookup";

export class SiteLevelMilestoneDetailsTab {

    tableId: string = "site-milestone-details-table";
    tableWrapperId: string = this.tableId + "_wrapper";
    dataTable: any;
    tableColumnController: TableColumnVisibilityController;

    constructor(milestonesBySite: MilestonesBySite[], milestoneIdsToShow: number[]) {

        let columns: any[] = [
            { data: { _: "SiteNameDisplay", sort: "SiteName" }, title: "Site Name", className: "text-left font-size12" },
            { data: { _: "SiteNumberDisplay", sort: "SiteNumber" }, title: "Site Id", className: "site-id text-center font-size12 nowrap" },
            { data: "PrimeContract", title: "Platform", className: "prime-contract text-center font-size12 nowrap" },
            { data: "PI", title: "Investigator", className: "contacts text-center font-size12 nowrap", render: RenderNullableString }
        ];

        let tableColumnGroups: TableColumnGroup[] = [
            new TableColumnGroup("Site Id", true, [], "site-id"),
            new TableColumnGroup("Platform", true, [], "prime-contract"),
            new TableColumnGroup("Investigator", true, [], "contacts"),
            new TableColumnGroup("Selection", true, [], "site-selection"),
            new TableColumnGroup("Contracts", true, [], "site-contracts"),
            new TableColumnGroup("Initiation", true, [], "site-initiation"),
            new TableColumnGroup("Activation", true, [], "site-activation"),
        ];

        milestoneIdsToShow.forEach((id: number) => {
            let name: string = SiteActivationLookup.GetMilestone(id);
            let css_name: string = "";
            if (id == 1 || id == 6 || id == 22 || id == 25) { css_name = "site-selection"; }
            else if (id == 32 || id == 24 || id == 33 || id == 30 || id == 34 || id == 26) { css_name = "site-contracts"; }
            else if (id == 27 || id == 8 || id == 9 || id == 10 || id == 14 || id == 31 || id == 16 || id == 36) { css_name = "site-initiation"; }
            else if (id == 17 || id == 19 || id == 35) { css_name = "site-activation"; }

            if (css_name.length > 0) {
                columns.push({ data: "MilestoneCompletionDates." + id, title: name.split(" ").join("<br>"), className: (css_name + " text-center font-size12 nowrap"), render: RenderDateMDY, defaultContent: '' });
            }
        });

        columns.push({ data: "RandomizedCount", title: "Participants<br>Randomized", className: "site-activation text-center font-size12 nowrap", render: RenderNullableNumberWithSeparators });

        this.dataTable = $('#' + this.tableId).DataTable({
            "dom": '<"top-controls"<"column-select"><"search-bar"f><"spacer"><"count-found"B>>rtip',
            autoWidth: true,
            info: false,
            paging: true,
            pagingType: 'simple',
            pageLength: 50,
            search: true,
            scrollX: true,
            scrollY: '70vh',
            scrollCollapse: true,
            orderCellsTop: true,
            fixedColumns: {
                leftColumns: 1
            },
            columns: columns,
            buttons: [
                {
                    extend: 'csv',
                    text: '<i class="fas fa-file-download"></i>',
                    titleAttr: 'CSV',
                    charset: 'utf-8',
                    //exportOptions: {
                    //    columns: [1, 2, 3, 4]
                    //}
                }
            ],
            //order: [[1, 'asc'], [7, 'asc']],
            data: milestonesBySite
        });

        $("#" + this.tableWrapperId + " .top-controls").addClass('row mx-0');

        $("#" + this.tableWrapperId + " .column-select").addClass('col-12 col-md-3 px-0');
        $("#" + this.tableWrapperId + " .column-select").empty().html('<div id="' + this.tableId + '-column-select"></div>');

        $("#" + this.tableWrapperId + " .search-bar").addClass('col-12 col-md-3');

        $("#" + this.tableWrapperId + " .spacer").addClass('col-12 col-md-3');
        $("#" + this.tableWrapperId + " .count-found").addClass('col-12 col-md-3 d-flex justify-content-end vertical-align-middle align-self-end mt-2 pr-0');
        //<span id="people-found-count" class="font-italic font-size12" > </span>
        $("#" + this.tableWrapperId + " .count-found").prepend('<div class=\"table-message d-inline-block align-self-center mr-2\"><span id=\"' + this.tableId + '-found-count\"></span></div>');
        $("#" + this.tableWrapperId + " .count-found").prepend('<div class=\"table-message d-inline-block align-self-center mr-2\"></div>');

        this.tableColumnController = new TableColumnVisibilityController(this.tableId, (this.tableId + '-column-select'), tableColumnGroups);

        $('#' + this.tableId).on('search.dt', (e, settings) => {
            this.setCountFoundLabel(this.dataTable.rows({ search: 'applied' }).count());
        });
        this.setCountFoundLabel(milestonesBySite.length);
    }

    setCountFoundLabel(count: number): void {

        switch (count) {
            case 0: $('#' + this.tableId + '-found-count').text("No Sites Found"); break;
            case 1: $('#' + this.tableId + '-found-count').text("1 Site Found"); break;
            default: $('#' + this.tableId + '-found-count').text(FormatNumberWithCommas(count + "") + " Sites Found");
        }
    }

    refresh(): void {
        this.dataTable.columns.adjust();
        this.tableColumnController.refresh();
    }

    updateContent(milestonesBySite: MilestonesBySite[]): void {
        this.dataTable.clear();
        this.dataTable.rows.add(milestonesBySite).draw();
        this.setCountFoundLabel(milestonesBySite.length);
    }

    clearSearchBar(): void {
        this.dataTable.search('').draw();
    }
}